/* eslint-disable no-sequences */
import React from 'react';

import Return from '../../../images/return.png';

import { FaRegBell } from 'react-icons/fa';

import { BaSeButton, BaSeIcon, BaSeTag } from '@base/react';
import { AddPushModel } from './addPush.model';
import DatePicker from 'react-multi-date-picker';
import DatePanel from 'react-multi-date-picker/plugins/date_panel';

import { mapValueMsg } from './mapValuesPage';
import { formatDefaultValueSelect } from '../../../utils/mask';
import { formatDateToBR } from '../../../utils/time';

import styles from './styles.module.scss';

export const DEFAULT_VALUE_SELECIONE = 'Selecione';
export const DEFAULT_VALUE_ALL = 'Todos';

export const AddPush = (props) => {
  const { onClose, selectedRow, allValuesOptions, typeScreen } = props;

  const {
    notificacao,
    setNotificacao,
    isLoadingCidades,
    // setIsLoadingCidades,
    // error,
    // setError,
    cidades,
    // updateCidades,
    // clearCidades,
    // isLoading,
    // setIsLoading,
    newCPF,
    setNewCPF,
    // newCNPJ,
    // setNewCNPJ,
    isCPF,
    setIsCPF,
    planilha,
    setPlanilha,
    // filterMenu,
    // funcoesBackup,
    removeCPF,
    updateValue,
    updatePlanilha,
    recoveredByid,
    adicionarNotificacao,
    onChangeUF,
    updatePics,
    subMenu,
    setSubMenus,
    cnaes,
    setCnaes,
    // lackingFields,
  } = AddPushModel({ selectedRow, typeScreen, onClose });

  const backList = () => {
    onClose();
  };

  const CustomMultipleInput = ({ openCalendar, stringDates }) => {
    return (
      <input onFocus={openCalendar} value={stringDates.join(', ')} readOnly />
    );
  };

  return (
    <div>
      <div className={styles.container_principal}>
        <div
          className={styles.filtro_container}
          style={{ backgroundColor: '#FF9933' }}
        >
          <div className={styles.modal_flex_direction_row}>
            <FaRegBell size={40} color="#ffffff" />
            <h2 className={styles.text_color_branco_titulo}>Notificações</h2>
            <div className={styles.div_acoes_carrossel}>
              <div className={styles.icons_acoes_modal_filtro}>
                <img
                  onClick={backList}
                  alt="imagem"
                  className={styles.writin}
                  src={Return}
                />
                <p className={styles.text_color_branco}>Voltar</p>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div className={styles.div_tabelas_pushs_filtro}>
            <div className={styles.separator_push}>
              <h3>{mapValueMsg[typeScreen]}</h3>
            </div>

            <div className={styles.render_big_container_up}>
              <div className={styles.content_left}>
                {/* linha 1 */}
                <div>
                  <div className={styles.container_itens}>
                    <p className="text-campos-cadastro">
                      Título da Notificação{' '}
                      <span className={styles.mandatory_push}>*</span>
                    </p>
                  </div>
                  <input
                    value={notificacao?.titulo ?? ''}
                    id="input-nome"
                    onChange={(evento) => {
                      const newValue = evento.target.value;
                      if (newValue.length < 141)
                        updateValue('titulo', evento.target.value);
                    }}
                    placeholder="Digite aqui o título"
                  />
                  <div className={styles.sublabel_wrapper}>
                    <p className={styles.sublabel}>
                      {notificacao?.titulo?.length ?? 0}/140
                    </p>
                  </div>
                </div>

                {/* linha 2 */}
                <div>
                  <p className="text-campos-cadastro">
                    Descrição da notificação
                    <span className={styles.mandatory_push}>*</span>
                  </p>
                  <textarea
                    rows="7"
                    value={notificacao?.descricao ?? ''}
                    id="input-descricao"
                    onChange={(evento) => {
                      const newValue = evento.target.value;
                      if (newValue.length < 501)
                        updateValue('descricao', evento.target.value);
                    }}
                    placeholder="Digite aqui a descrição da funcionalidade"
                  />
                  <div className={styles.sublabel_wrapper}>
                    <p className={styles.sublabel}>
                      {notificacao?.descricao?.length ?? 0}/500
                    </p>
                  </div>
                </div>

                {/* linha 3 */}
                <div className={styles.menu_submenu_row}>
                  <div>
                    <p className="text-campos-cadastro">
                      Menu relacionado
                      <span className={styles.mandatory_push}>*</span>
                    </p>
                    <select
                      value={notificacao?.menu?.id ?? ''}
                      className="btn-select-funcionalidades height-36"
                      onChange={(event) => {
                        updateValue('menu', parseInt(event.target.value));
                        if (event.target.value !== DEFAULT_VALUE_SELECIONE) {
                          const recovered = recoveredByid(
                            allValuesOptions.menus,
                            event.target.value,
                            false
                          );
                          setSubMenus(recovered.subMenus);
                          updateValue('menu', recovered);
                        } else {
                          setSubMenus([]);
                        }
                      }}
                    >
                      <option value={null}>{DEFAULT_VALUE_SELECIONE}</option>
                      {allValuesOptions.menus.map((mn) => {
                        return (
                          <option value={mn.id} title={mn.nome}>
                            {mn.nome}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                  <div>
                    <p className="text-campos-cadastro">
                      Submenu relacionado
                      <span className={styles.mandatory_push}>
                        {notificacao?.menu?.subMenus?.length > 0 ? '*' : ''}
                      </span>
                    </p>
                    <select
                      value={notificacao?.subMenu?.id ?? ''}
                      className="btn-select-funcionalidades height-36"
                      onChange={(event) => {
                        const recovered = recoveredByid(
                          subMenu,
                          event.target.value,
                          false
                        );
                        updateValue('subMenu', recovered);
                      }}
                    >
                      <option value={null}>{DEFAULT_VALUE_SELECIONE}</option>
                      {subMenu.map((sm) => {
                        return (
                          <option value={sm.id} title={sm.nome}>
                            {sm.nome}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                </div>
              </div>
              <div className={styles.content_right}>
                {/* linha  1*/}
                <p style={{ display: 'inline' }}>
                  Data e hora de envio da Notificação
                  <span className={styles.mandatory_push}>*</span>
                </p>
                <div className={styles.data_hora_row_container}>
                  <div className={styles.data_hora_row}>
                    <div>
                      <div>
                        <DatePicker
                          minDate={new Date()}
                          multiple
                          value={notificacao?.datasEnvio ?? ''}
                          type="custom"
                          format="DD/MM/YYYY"
                          onChange={(e) => {
                            const datas = e.map((dt) => {
                              const { year, month, day } = dt;
                              return new Date(year, month - 1, day);
                            });
                            updateValue('datasEnvio', datas);
                          }}
                          render={<CustomMultipleInput />}
                          plugins={[<DatePanel />]}
                        />
                      </div>
                    </div>
                    <div>
                      <select
                        value={notificacao?.horaEnvio ?? '08:00'}
                        id={styles.hora}
                        name="hora"
                        className="width-complete height-36"
                        onChange={(event) => {
                          updateValue('horaEnvio', event.target.value);
                        }}
                      >
                        <option value={8}>08:00</option>
                        <option value={14}>14:00</option>
                        <option value={20}>20:00</option>
                      </select>
                    </div>
                  </div>
                  <div className={styles.dt_expiracao}>
                    <p>Data de expiração</p>
                    <div>
                      <div>
                        <DatePicker
                          disabled={
                            notificacao?.datasEnvio?.length > 1 ? true : false
                          }
                          format="DD/MM/YYYY"
                          value={notificacao?.dataExpiracao ?? ''}
                          type="custom"
                          onChange={(e) => {
                            const { year, month, day } = e;
                            updateValue(
                              'dataExpiracao',
                              `${day < 10 ? `0${day}` : day}-${
                                month < 10 ? `0${month}` : month
                              }-${year}`
                            );
                          }}
                          render={(stringDate, openCalendar) => {
                            return (
                              <input
                                onFocus={openCalendar}
                                value={stringDate}
                                readOnly
                              />
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                {/* linha  2*/}
                <div>
                  <div>
                    <p>
                      Recorrência
                      <span className={styles.mandatory_push}>*</span>
                    </p>
                    <select
                      disabled={
                        notificacao?.datasEnvio?.length > 1 ? true : false
                      }
                      value={notificacao?.recorrencia ?? ''}
                      className="btn-select-funcionalidades height-36"
                      onChange={(event) => {
                        updateValue('recorrencia', event.target.value);
                      }}
                    >
                      <option value={null}>{DEFAULT_VALUE_SELECIONE}</option>
                      {allValuesOptions.recorrencias.map((rcr) => (
                        <option value={rcr} title={rcr}>
                          {formatDefaultValueSelect(rcr)}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                {/* linha  3*/}
                <div>
                  <div>
                    <p className="text-campos-cadastro">
                      Perfis<span className={styles.mandatory_push}>*</span>
                    </p>
                    <select
                      value={notificacao?.perfis?.[0]?.id ?? ''}
                      className="btn-select-funcionalidades height-36"
                      onChange={(event) => {
                        const recovered = recoveredByid(
                          allValuesOptions.perfis,
                          event.target.value,
                          true
                        );
                        updateValue('perfis', recovered);
                      }}
                    >
                      <option value={null}>{DEFAULT_VALUE_ALL}</option>
                      {allValuesOptions.perfis.map((pr) => (
                        <option value={pr.id} title={pr.nome}>
                          {formatDefaultValueSelect(pr.nome)}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                {/* linha 4 */}
                <div className={styles.img_row}>
                  <div>
                    <div>
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                        }}
                      >
                        <p className="text-campos-cadastro">Imagem</p>
                        <label
                          for="image-input"
                          style={{ marginTop: '17px', cursor: 'pointer' }}
                          id="label-icon"
                        >
                          <BaSeIcon
                            size={22}
                            name="image-upload"
                            color="#FF9933"
                            description="teste"
                          />
                        </label>
                      </div>
                      <div>
                        <div className="size-45">
                          <input
                            id="image-input"
                            // className="hide-input"
                            style={{ display: 'none' }}
                            accept="image/*"
                            type="file"
                            onChange={(event) => updatePics('imagem', event)}
                          />
                          <div className={styles.image_container}>
                            {notificacao.imagem && (
                              <img
                                src={`data:image/png;base64, ${notificacao.imagem.base64}`}
                                alt=""
                              />
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className={styles.btn_video}>
                    <div>
                      <div>
                        <p>
                          <p className="text-campos-cadastro">
                            Texto para o botão{' '}
                            <span className={styles.mandatory_push}>*</span>
                          </p>
                        </p>
                        <input
                          value={notificacao?.textoBotao ?? ''}
                          id="input-nome"
                          onChange={(evento) =>
                            updateValue('textoBotao', evento.target.value)
                          }
                          placeholder="Digite aqui o texto do botão"
                        />
                      </div>
                    </div>
                    <div>
                      <div>
                        <p>
                          <p className="text-campos-cadastro">URL do vídeo</p>
                        </p>
                        <input
                          value={notificacao?.urlConteudo ?? ''}
                          id="input-URL"
                          onChange={(evento) =>
                            updateValue('urlConteudo', evento.target.value)
                          }
                          placeholder="Digite aqui a url"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className={styles.div_acoes_pushs}>
              <div className={styles.container_itens}></div>
            </div>

            <div className={styles.separator_push}>
              <h3>Abrangência da notificação</h3>
            </div>

            <div className={styles.div_acoes_pushs}>
              <div className={styles.container_itens}>
                <div className={styles.local_wrapper}>
                  <div>
                    <p className="text-campos-cadastro">UF</p>
                    <select
                      style={{ width: '100px', marginRight: '1rem' }}
                      value={notificacao?.ufs?.[0]?.id ?? ''}
                      className="btn-select-funcionalidades"
                      onChange={(event) =>
                        onChangeUF(allValuesOptions.ufs, event.target.value)
                      }
                    >
                      <option value={null}>{DEFAULT_VALUE_SELECIONE}</option>
                      {allValuesOptions.ufs.map((uf) => (
                        <option value={uf.id} title={uf.nome}>
                          {uf.nome}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div>
                    <p className="text-campos-cadastro">Cidade</p>
                    <select
                      style={{ width: '150px' }}
                      disabled={isLoadingCidades}
                      value={notificacao?.cidades?.[0]?.id ?? ''}
                      className="btn-select-funcionalidades"
                      onChange={(event) => {
                        const recovered = recoveredByid(
                          cidades,
                          event.target.value,
                          true
                        );
                        updateValue('cidades', recovered);
                      }}
                    >
                      {isLoadingCidades ? (
                        <option value={null}>Carregando cidades</option>
                      ) : (
                        <>
                          <option value={null}>
                            {DEFAULT_VALUE_SELECIONE}
                          </option>
                          {cidades.map((cidade) => (
                            <option value={cidade.id} title={cidade.nome}>
                              {cidade.nome}
                            </option>
                          ))}
                        </>
                      )}
                    </select>
                  </div>
                </div>
              </div>
              <div className={styles.container_itens}></div>
            </div>
            <div className={styles.div_acoes_pushs}>
              <div className={styles.container_itens}>
                <div
                  className="accordion-content flex-1 column"
                  style={{ flex: 1 }}
                >
                  <div>
                    <p
                      className="color-label text-campos-cadastro"
                      style={{ marginBottom: '5px' }}
                    >
                      Tipo de usuário
                    </p>
                    <div
                      style={{ display: 'flex', flexDirection: 'row', flex: 1 }}
                    >
                      <div style={{ display: 'flex', flexDirection: 'row' }}>
                        <input
                          type="radio"
                          value={isCPF}
                          checked={isCPF}
                          onChange={() => {
                            setIsCPF(true);
                            setNotificacao({
                              ...notificacao,
                              cnpjs: [null],
                              portes: [null],
                              cnaes: [null],
                              segmentos: [null],
                            });
                          }}
                        />
                        <label
                          className={styles.color_label}
                          style={{ color: '#6c6c6c' }}
                        >
                          CPF
                        </label>
                      </div>
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          marginLeft: 10,
                        }}
                      >
                        <input
                          type="radio"
                          value={isCPF}
                          checked={!isCPF}
                          onChange={() => {
                            setIsCPF(false);
                            setNotificacao({
                              ...notificacao,
                              cpfs: [],
                            });
                          }}
                        />
                        <label
                          className={styles.color_label}
                          style={{ color: '#6c6c6c' }}
                        >
                          CNPJ
                        </label>

                        {/* Adicionar nome avulso */}
                        <input
                          style={{ marginLeft: '5px' }}
                          placeholder={'Insira um CPF'}
                          type="text"
                          onChange={(event) => setNewCPF(event.target.value)}
                          // value={newCPF}
                          className="margin-left-20"
                        />

                        <div class="margin-left-5">
                          <BaSeIcon
                            name="plus-circle"
                            size={22}
                            color="#6c6c6c"
                            description="Ícone de adicionar CPF"
                            onClick={() =>
                              setPlanilha([...planilha, newCPF ?? [newCPF]])
                            }
                          />
                        </div>
                        <label for="planilha" className="margin-left-5">
                          <BaSeIcon
                            name="document"
                            size={22}
                            color="#6c6c6c"
                            description="Ícone de adicionar lista"
                          />
                        </label>

                        {/* input de planilha escondido */}
                        <input
                          type="file"
                          id="planilha"
                          accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                          onChange={(event) => updatePlanilha(event)}
                          // className="hide-input"
                          style={{ display: 'none' }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className={styles.container_itens}>
                <div className="cpfs-container">
                  {planilha &&
                    planilha.length > 0 &&
                    planilha.map((cpf, index) => (
                      <BaSeTag
                        borderColor="transparent"
                        iconBackgroundColor="#db340b"
                        iconColor="#ffffff"
                        label={cpf}
                        labelBackgroundColor="#cfe2fc"
                        labelColor="#005eb8"
                        onClose={() => removeCPF(index)}
                        size="medium"
                      />
                    ))}
                </div>
              </div>
            </div>

            {!isCPF && (
              <div className={styles.div_acoes_pushs}>
                <div className={styles.container_itens}>
                  <p className="text-campos-cadastro">Porte</p>
                  <select
                    value={notificacao?.portes?.[0]?.id ?? ''}
                    className="btn-select-funcionalidades"
                    onChange={(event) => {
                      const recovered = recoveredByid(
                        allValuesOptions.portes,
                        event.target.value,
                        true
                      );
                      updateValue('portes', recovered);
                    }}
                  >
                    <option value={null}>{DEFAULT_VALUE_SELECIONE}</option>
                    {allValuesOptions.portes.map((pte) => (
                      <option value={pte.id} title={pte.nomePorte}>
                        {pte.nomePorte}
                      </option>
                    ))}
                  </select>
                </div>

                <div className={styles.container_itens}>
                  <p className="text-campos-cadastro">Segmentos</p>
                  <select
                    value={notificacao?.segmentos?.[0]?.id ?? ''}
                    className="btn-select-funcionalidades"
                    onChange={(event) => {
                      // const value = event.target.value;
                      updateValue('segmentos', parseInt(event.target.value));
                      if (event.target.value !== DEFAULT_VALUE_SELECIONE) {
                        const recovered = recoveredByid(
                          allValuesOptions.segmentos,
                          event.target.value,
                          true
                        );

                        setCnaes(recovered?.[0].cnaes);
                        updateValue('segmentos', recovered);
                      } else {
                        setCnaes([]);
                      }
                    }}
                  >
                    <option value={null}>{DEFAULT_VALUE_SELECIONE}</option>
                    {allValuesOptions.segmentos.map((seg) => (
                      <option value={seg.id} title={seg.nome}>
                        {seg.nome}
                      </option>
                    ))}
                  </select>
                </div>

                <div className={styles.container_itens}>
                  <p className="text-campos-cadastro">Cnae:</p>
                  <select
                    value={notificacao?.cnaes?.[0]?.id ?? ''}
                    className="btn-select-funcionalidades"
                    onChange={(event) => {
                      const recovered = recoveredByid(
                        notificacao?.segmentos?.[0].cnaes,
                        event.target.value,
                        true
                      );
                      updateValue('cnaes', recovered);
                    }}
                  >
                    <option value={null}>{DEFAULT_VALUE_SELECIONE}</option>
                    {cnaes.map((cnae) => (
                      <option value={cnae.id} title={cnae.descricao}>
                        {cnae.descricao}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            )}
            <div
              className={styles.div_acoes_pushs}
              style={{ marginTop: '10px', marginBottom: '10px' }}
            >
              <div
                className={styles.container_itens}
                style={{ display: 'flex' }}
              >
                <div
                  style={{
                    display: 'flex',
                    flex: '1',
                    justifyContent: 'space-between',
                  }}
                >
                  <div style={{ flex: 1 }}>
                    <p className="text-campos-cadastro">Usuários que </p>
                    <select
                      value={notificacao?.usuariosQue ?? ''}
                      className="btn-select-funcionalidades"
                      onChange={(event) => {
                        updateValue('usuariosQue', event.target.value);
                      }}
                    >
                      <option value={null}>{DEFAULT_VALUE_SELECIONE}</option>
                      {allValuesOptions.usuariosQue.map((uq) => (
                        <option value={uq} title={uq}>
                          {formatDefaultValueSelect(uq)}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div style={{ flex: 1, alignSelf: 'flex-end' }}>
                    <BaSeButton
                      color="#FF9933"
                      value={
                        typeScreen !== 3
                          ? 'Incluir notificação'
                          : 'Editar Notificação'
                      }
                      onClick={adicionarNotificacao}
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* Resgistro data INCLUSÃO-ALTERAÇÃO */}
            <div className={styles.updatedAt_notificacao_container}>
              {notificacao.atualizadoPor && typeScreen === 3 && (
                <h5>
                  Atualizado em {formatDateToBR(notificacao.ultimaAtualizacao)}{' '}
                  por {notificacao?.atualizadoPor?.nome}
                </h5>
              )}
              {notificacao.criadoPor && typeScreen === 3 && (
                <h5>
                  Criado em {formatDateToBR(notificacao.dataCriacao)} por{' '}
                  {notificacao?.criadoPor?.nome}
                </h5>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
